/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type BlankEnum = typeof BlankEnum[keyof typeof BlankEnum];


export const BlankEnum = {
  '': '',
} as const;
